module.exports = __webpack_public_path__ + "static/media/sparrow-eating-momo.94882250.gif";